<template>
  <NTag
    checkable
    :checked="isChecked"
    class="select-none cursor-pointer"
    :disabled="disabled"
    :on-update:checked="onOptionSelect"
    :style="{
      '--n-color-checkable': isChecked ? themeVars?.primary5 : themeVars?.primary6,
      '--n-color-hover-checkable': isChecked ? themeVars?.primary5 : themeVars?.primary6,
      '--n-height': '28px',
      border: `1px solid ${themeVars?.primary5}`,
    }"
    :themeOverrides="{
      borderRadius: '4px',
    }"
  >
    <div class="flex gap-1">
      <span>{{ name }}</span>
      <CIcon v-if="isChecked" icon="check" />
    </div>
  </NTag>
</template>

<script lang="ts" setup>
import { NTag } from 'naive-ui'
import { computed } from 'vue'

import useThemeVars from '@lib/composables/useThemeVars'
import CIcon from '@lib/components/CIcon/CIcon.vue'

type Props = {
  disabled?: boolean
  name?: string
  modelValue?: boolean | string | null
}

const props = defineProps<Props>()

const emit = defineEmits<(event: 'update:modelValue', value: boolean) => void>()

const themeVars = useThemeVars()

const isChecked = computed(() => {
  if (typeof props.modelValue === 'string') {
    return props.modelValue === 'true'
  }
  return !!props.modelValue
})

function onOptionSelect(checked: boolean) {
  emit('update:modelValue', checked)
}
</script>
